import { Typography, withStyles } from "@material-ui/core";
import { Button, Card } from "bc-front-sagacomponents";
import React from "react";
import { Assisteur } from "../../../services/Api/swagger";
import history from "../../../services/history";
import styles from "../style";

interface Props {
  classes?: any;
  infoAssisteur?: Assisteur[];
}
const BlocContact = (props: Props) => {
  const { classes, infoAssisteur } = props;

  return (
    <Card className={classes.contactBloc}>
      <Typography variant="h3">Contact</Typography>

      {infoAssisteur &&
        infoAssisteur[0] &&
        infoAssisteur[0].nom &&
        infoAssisteur[0].telephone && (
          <>
            {" "}
            <div className={classes.contactAssisteur}>
              <p>
                Pour toute demande d’assistance (prêt de véhicule, demande de
                stage pour perte de points, etc.)* contacter{" "}
                {infoAssisteur[0].nom} :{" "}
                <a href={"tel:" + infoAssisteur[0].telephone}>{infoAssisteur[0].telephone}</a>
              </p>
            </div>
            <br />
          </>
        )}
      <div>Pour toute autre demande contacter Saga Service Plus</div>
      <Button
        variant="contained"
        color="primary"
        title="Contactez nous"
        onClick={() => history.push("/contact")}
      />

      {infoAssisteur && (
        <div>
          <br />
          <span>* Selon la formule souscrite</span>
        </div>
      )}
    </Card>
  );
};

export default withStyles(styles)(BlocContact);
